<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="dta_title mar-tb-20 pad-lr-15"> Weekly View for Supplier </div>

<form name="form" (ngSubmit)="updateweeklyData()" #f="ngForm" novalidate>
  <div class="row no-mar-lr alin-center">
    <div class="form-group col-md-2 mar-top-30">
      <label>Supplier Code</label>
      <ng-multiselect-dropdown *ngIf="supplierCodeList != undefined" class="form-control" name="suppliercodes" [settings]="settingssuppliercode" [data]="supplierCodeList" [(ngModel)]="suppliercodes" 
        (onSelect)="onSingleSelectSupplierCode($event)" (onDeSelect)="onDeSelectSupplierCode($event)" (onSelectAll)="onSelectAllSupplierCode($event)"
        (onDeSelectAll)="DeSelectAllSupplierCode($event)"></ng-multiselect-dropdown>
    </div>
    <div class="form-group col-md-2 mar-top-30">
      <label>Select Duration</label>
      <p-calendar name="datevalue" [showIcon]="true" [(ngModel)]="rangeDates" dateFormat="dd-mm-yy" selectionMode="range"></p-calendar>
      </div>
    <div class="form-group col-md-2 " style="margin-top:63px">
        <label>&nbsp;</label>
        <button type="submit" value="Register" class="btn btn-primary black">Apply</button>
      </div>
  </div>
</form>

<section class="container">
  <div class="row mar-top-50">
    <div class="col-md-4 ">
      <label class= "alin-center">Weight ( in kg )</label>
      <p-chart type="pie" [data]="weightData" width="130" height="225" [options]="piechartoptions"></p-chart>
    </div>

    <div class="col-md-4 ">
      <label class= "alin-center">Volume ( in metric cube )</label>
      <p-chart type="pie" [data]="volumeData" width="130" height="225" [options]="piechartoptions" style="    height: 316px;
      width: 350px;"></p-chart>
    </div>


    <div class="col-md-4 ">
      <label class= "alin-center">Number of Parts</label>
      <p-chart type="pie" [data]="noofpartData" width="130" height="225" [options]="piechartoptions"></p-chart>
    </div>
  </div>
</section>